import _ from 'lodash';
import timm from 'timm';

import { Types } from 'app/actions/page-volunteer-me';
import utils from 'app/reducers/utils';

const initialState = {
  loadPending: false,
};

const reducer = utils.createReducer(initialState, {

  [`${Types.LOAD}_PENDING`]: (state, action) => {
    return {...state,
      loadPending: true,
    };
  },
  [`${Types.LOAD}_RESOLVED`]: (state, action) => {
    return {...state,
      loadPending: false,
    };
  },
  [`${Types.LOAD}_REJECTED`]: (state, action) => {
    return {...state,
      loadPending: false,
    };
  },


});

export default reducer;
